/* eslint-disable import/no-named-default */
import type { FC } from 'react';
import { useRouter } from 'next/router';

import { parsePage } from 'Components/Account/AccountPage.helpers';
import useAccountRouter from 'Components/Account/useAccountRouter';
import { triggerAccountPaginationEvent } from 'Services/analytics/events';
import type { PaginationProps } from 'Storybook/core/Pagination/Pagination';
import { default as PaginationComponent } from 'Storybook/core/Pagination/Pagination';

type PaginationWrapperProps = Omit<PaginationProps, 'page'>;

export const Pagination: FC<PaginationWrapperProps> = ({
	isDisabled = false,
	queryStatus,
	recordsPerPage,
	totalRecords,
}) => {
	const { query } = useRouter();

	const { slug } = useAccountRouter();

	const pageInt = parsePage(query, 1);

	const paginationGAEventHandler = (pageNumber: number) => {
		triggerAccountPaginationEvent(slug, String(pageNumber));
	};

	return (
		<PaginationComponent
			isDisabled={isDisabled}
			onClick={paginationGAEventHandler}
			page={pageInt}
			queryStatus={queryStatus}
			recordsPerPage={recordsPerPage}
			totalRecords={totalRecords}
		/>
	);
};
